import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonService } from '../../../providers/person.service';
import { AddPersonViewService } from '../providers/add-person-view.service';
import { Person } from '../../../models/person';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { ModalConfirmDialogComponent } from '../../modal-confirm-dialog/modal-confirm-dialog.component';
import { faPlus, faUser, faTrash, faEye, faEdit }  from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-my-people',
  templateUrl: './my-people.component.html',
styleUrls:  ['./my-people.component.css']
})
export class MyPeopleComponent extends SmsAbstractAppPage implements OnInit {
	show_more_person: boolean[] = [];
	show_edit_person: boolean[] = [];
  person_save_in_progress: boolean[] = [];
	faPlus = faPlus;
	faUser = faUser;
	faTrash = faTrash;
	faEye = faEye;
	faEdit = faEdit;
	people_list: Person[] = [];

  constructor(private modal: NgbModal, private personService: PersonService, private addPersonViewService: AddPersonViewService) {
  	super();
  }

  ngOnInit() {
  	this.personService.getList().then(people => {
  		this.people_list = people;

  		this.initBooleanViewFlags();

  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleAddPerson(){
  	this.addPersonViewService.doAddPerson().then(new_person => {
         this.personService.create(new_person).then(person => {
         	this.people_list.push(person);
         	this.personService.sortPeopleList(this.people_list);
         	this.initBooleanViewFlags();
         }).catch(error => {
           this.handleError(error);
         });

  	}).catch(error => {
  		this.handleError(error);
  	});

  }

  handleHidePerson(person: Person){
  	let modal_ref_confirm = this.modal.open(ModalConfirmDialogComponent, {size: 'sm'});
     modal_ref_confirm.componentInstance.title = 'HIDE ' + person.first_name + " " + person.last_name + "!";

     let str_message: string =  "Please confirm that you want to remove " + person.first_name + " " + person.last_name + " from your list of people.";

     str_message += "If you remove "+ person.first_name + " " + person.last_name + " from your account, they will still appear on any entries you've previously created but they will no longer appear as a choice in your list.";

     modal_ref_confirm.componentInstance.message = str_message;


     modal_ref_confirm.componentInstance.yes$.subscribe(response => {
       if(response){
         modal_ref_confirm.close();
         this.personService.hide(person).then(response => {
           if(response){
             this.people_list.forEach((l_person, i) => {
               if(l_person.id == person.id){
                 this.people_list.splice(i, 1);
               }
             });
           }
         }).catch(error => {
           this.handleError(error);
         });
       }
     }, error => {
       this.handleError(error);
       modal_ref_confirm.close();
     });

  }

  onSavePerson(person: Person, index: number){
      this.person_save_in_progress[index] = true;
  	this.personService.update(person).then(updated_person => {
  		this.people_list[index] = updated_person;
  		this.show_more_person[index] = false;
  		this.show_edit_person[index] = false;
      this.person_save_in_progress[index] = false;
  	}).catch(error => {
  		this.handleError(error);
      this.person_save_in_progress[index] = false;
  	});
  }

  initBooleanViewFlags(){
  //init boolean arrays to show/hide view more and edit
  	this.show_more_person = [];
  	this.show_edit_person = [];
    this.person_save_in_progress = [];

	this.people_list.forEach((person, i) => {
		this.show_more_person.push(false);
		this.show_edit_person.push(false);
    this.person_save_in_progress.push(false);
	});
  }
}
